// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3115c03","239":"1d82f4cb","455":"f5d3852d"}[chunkId] + ".chunk.js";
};